import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../Shared/Icon/Icon'

function EmptyResults({
  title, icon, buttons = null, children,
}) {
  return (
    <section className="projects-empty">
      <div className="projects-empty__header">
        <Icon type={['fas', icon]} size="10x" className="background-image" />

        <div className="header-text">
          <h3 className="heading-32" dangerouslySetInnerHTML={{ __html: title }} />
          {buttons}
        </div>
      </div>
      {children}
    </section>
  )
}

EmptyResults.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  buttons: PropTypes.object,
}

export default EmptyResults
